import { render, staticRenderFns } from "./AdminPostGroupsByPost.vue?vue&type=template&id=58b4da86"
import script from "./AdminPostGroupsByPost.vue?vue&type=script&lang=js"
export * from "./AdminPostGroupsByPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports